import { render, staticRenderFns } from "./ClientDemographicsLookupTable.vue?vue&type=template&id=79a3a5b8"
import script from "./ClientDemographicsLookupTable.vue?vue&type=script&lang=js"
export * from "./ClientDemographicsLookupTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports